import { common, mstCommon } from '@libs/domain';
import { Characters, Item, labelName } from '@ps-smart-cp/ppfw-client';

const mstImportFieldConfig = {
  file: Item.of(common.names.file, common.attributes.file),
  importClass: Item.of(common.names.importClass, common.attributes.importClass),
  jobComment: Item.of(common.names.jobComment, common.attributes.jobComment),
  characterCode: Item.of(common.names.characterCode, common.attributes.characterCode),
};

const mstRegistrationFieldConfig = {
  code: Item.of(mstCommon.names.code, mstCommon.attributes.code),
  name: Item.of(mstCommon.names.name, mstCommon.attributes.name),
  mstSpareName01: Item.of(mstCommon.names.mstSpareName01, mstCommon.attributes.mstSpareName01),
  mstSpareName02: Item.of(mstCommon.names.mstSpareName02, mstCommon.attributes.mstSpareName02),
  validityStartDate: Item.of(mstCommon.names.validityStartDate, mstCommon.attributes.validityStartDate),
  validityEndDate: Item.of(mstCommon.names.validityEndDate, mstCommon.attributes.validityEndDate),
  mstNote: Item.of(mstCommon.names.mstNote, mstCommon.attributes.mstNote),
};

const mstListSearchFieldConfig = {
  codeRange: Item.of(mstCommon.names.codeRange, mstCommon.attributes.codeRange),
  name: Item.of(mstCommon.names.name, mstCommon.attributes.name.replaceRequired(false)),
  mstSpareName01Condition: Item.of(
    mstCommon.names.mstSpareName01Condition,
    mstCommon.attributes.mstSpareName01Condition,
  ),
  mstSpareName02Condition: Item.of(
    mstCommon.names.mstSpareName02Condition,
    mstCommon.attributes.mstSpareName02Condition,
  ),
  validityStartDateCondition: Item.of(
    mstCommon.names.validityStartDateCondition,
    mstCommon.attributes.validityStartDateCondition,
  ),
  validityEndDateCondition: Item.of(
    mstCommon.names.validityEndDateCondition,
    mstCommon.attributes.validityEndDateCondition,
  ),
  mstNoteCondition: Item.of(mstCommon.names.mstNoteCondition, mstCommon.attributes.mstNoteCondition),
};

const outputOpsFieldConfig = {
  outputFileFormat: Item.of(common.names.outputFileFormat, common.attributes.outputFileFormat),
  jobComment: Item.of(common.names.jobComment, common.attributes.jobComment),
};

const outputOrderFieldConfig = {
  outputKey: Item.of(mstCommon.names.outputKey, mstCommon.attributes.outputKey),
};

const outputOrderUiFieldConfig = { key: Item.of(labelName.key, Characters.preset.freeFormat()) };

export {
  mstImportFieldConfig,
  mstListSearchFieldConfig,
  mstRegistrationFieldConfig,
  outputOpsFieldConfig,
  outputOrderFieldConfig,
  outputOrderUiFieldConfig,
};
